import React from 'react';
// Defined in general.js
/* global Uri */
import makeParams from './makeParams.js';


function useFullyFundedFilter(props) {
    const [checkFullyFundedFilter, setCheckFullyFundedFilter] = React.useState(false);

    const toggleFullyFundedFilter = function (applyFilters) {
        applyFilters(makeParams('historical', 'true', checkFullyFundedFilter));
        setCheckFullyFundedFilter(!checkFullyFundedFilter);
    };

    function isSelected(searchURL, paramName, value) {
        const url = new Uri(searchURL);
        return url.hasQueryParam(paramName, value);
    }

    React.useEffect(() => {
        setCheckFullyFundedFilter(isSelected(props.searchURL, 'historical', 'true'));
    }, [props.searchURL]);

    return [checkFullyFundedFilter, toggleFullyFundedFilter];
}

export default useFullyFundedFilter;
